<template>
  <div class="wdw-map-search-address input-group">
    <input
      type="text"
      v-model="address"
      @keyup.enter="searchAddress()"
      class="search-input form-control"
      placeholder="Suchen"
      aria-label="Adresse in Karte suchen"
      aria-describedby="search-button"
    />
    <button @click="searchAddress()" class="btn btn-primary btn-search-button" id="search-button">
      <font-awesome-icon icon="search"></font-awesome-icon>
    </button>
  </div>
  <Message
    class="popup-message wdw-map-search-address"
    @click="toggleMessage = false"
    :severity="messageInformation.severity"
    v-show="toggleMessage"
  >
    {{ messageInformation.text }}
  </Message>
</template>

<script>
import { ref } from '@vue/reactivity';
import Message from 'primevue/message';
import domainRepository from '@/api/domainRepository';

export default {
  name: 'MapSearchAddress',
  emits: ['addressCoordinatesReceived'],

  components: {
    Message,
    // InputText
  },

  setup(props, context) {
    const messageInformation = ref({});
    const address = ref('');
    const toggleMessage = ref(false);
    //functions
    function searchAddress() {
      domainRepository.searchAddress(address.value).then(response => {
        const apiData = response.data.data;
        let emitItem;
        let locationData;
        let queryAddress;

        //check if we get results
        if (apiData.status != 'ZERO_RESULTS') {
          queryAddress = apiData.results[0].formatted_address;

          //check if results are approximated or not

          if (apiData.is_approximate) {
            messageInformation.value = {
              severity: 'warn',
              text:
                'Die von Ihnen eingegebene Adresse konnte möglicherweise nicht gefunden werden.' +
                ' Die Meldung wird an der Adresse ' +
                queryAddress +
                ' platziert.' +
                ' Zur Änderung der Position geben Sie bitte eine andere Adresse über das Suchfeld ein,' +
                ' oder setzen Sie die Markerposition manuell über die Karte.',
            };

            toggleMessage.value = true;
          }
          //assign correct values and emit if its correct
          locationData = apiData.results[0].geometry.location;
          emitItem = { query: address.value, lon: locationData.lng, lat: locationData.lat, zoom: 18 };
          context.emit('addressCoordinatesReceived', emitItem);
        } else {
          messageInformation.value = {
            severity: 'error',
            text: 'Die eingegebene Adresse konnte leider nicht gefunden werden.',
          };
          toggleMessage.value = true;
        }
        address.value = '';
      });
    }

    return {
      address,
      toggleMessage,
      messageInformation,
      searchAddress,
    };
  },
};
</script>

<style scoped lang="scss">
div {
  margin-left: 2rem;
  width: 80%;
  height: fit-content;
  display: flex;
  justify-content: flex-end;
  align-content: center;
  align-items: center;
  @media (max-width: 769px) {
    width: 100%;
    margin-left: 0px;
  }
}
.search-input.form-control {
  border-radius: 0px;
  max-width: 60%;
  @media (max-width: 769px) {
    max-width: unset;
  }
}

@keyframes Box-Fade {
  0% {
    box-shadow: 0 0 0px 0px var(--wdw-primary-hover-color);
  }

  100% {
    box-shadow: 0 0 10px 2px var(--wdw-primary-hover-color);
  }
}
.popup-message {
  position: absolute;
  width: 80%;
  height: fit-content;
  left: 150px;
  top: 42px;
}
</style>
